module.exports = __webpack_public_path__ + "img/jrhy.97bad402.png";